
import { AuditModel } from "./auditModel";

export class Contact extends AuditModel {
  public clientId: number;
  public contactId: any = 0;
  public salutation: string;
  public accountingFirmId: number;
  public contestType: string;
  public firstName: string;
  public middleName: string;
  public lastname: string;
  public gender: string;
  public dateOfBirth: any;
  public dateOfDeath: any;
  public placeOfBirth: any;
  public contactType: any ='0';
  public phonenumber: any;
  public emailaddress: any;
  public companyName: any;
  public preferredname: any;
  public linkedinprofileID: any;
  public physicaladdressId: number = 0;
  public physicaladdress: string = '1';
  public physicaladdressline1: string;
  public physicaladdressline2: string;
  public physicalsuburb: string;
  public physicalstate: string;
  public physicalcountry: any;
  public physicalpostalpostcode: string;
  public physicalpostcode: string;
  public addressPoolContactMapping:any;
  public postaladdressId: number = 0;
  public postaladdress: string = '2';
  public postaladdressline1: string;
  public postaladdressline2: string;
  public postalsuburb: string;
  public postalstate: string;
  public postalpostcode: string;
  public postalcountry: any;
  public addresses: Address[] = [];
  public contactIds: string;
  public customfieldsData: string;
  public isSamePhysical: boolean = true;
  public strdateofbirth: string;
  public backgroundColor: string;
  public textColor: string;
  public din: string;
  public emailPoolClientMapping: any;
  public title: string;
  public phonePoolClientMapping: any;
}


export class JobNames {
    jobId: string;
    jobName: string;
}

export class CreditNoteFilter {
    fromdate: Date;
    todate: Date;
    status: any;
    balance: any;
}

export class CreditNoteDetails {
  CNId: any;
  creditNumber: string;
  used: any;
  balance: any;
  UserId: string;
  ClientId: any ;
  jobId: any = 0;
  jobName: string;
  creditDate: Date;
  narration: string;
  notes: string;
  amount: any;
  DocumentUrl: string;
  status: string;
  creditNoteNewNumber: string;
  totalAmount: any;
  creditnotecount: any;
}

export class AssigneeDetails {
  userId: any;
  name: any;
  role: any;
  rateperHour: any;
  time: any;
  cost: any;
}

export class WorkEmai {
  emailoption: string;
  emailstring: string;
  isemailbookmarked: boolean;
}

export class HomePhone {
  phoneoption: string;
  phonestring: string;
  isphonebookmarked: boolean;
}

export class JobDocDetail {
  docId: any;
  docTypeId: string;
  jobId: string;
  clientId: string;
  assignUserIds: string;
  jobTypeId: string;
  tagIds: string;
  entityTypeId: any;
  tagId: any;
  jobPrivacy: any;
}

export class DocumentViewDetail {
  documentId: any;
  documentTypeId: any;
  documentName: any;
  fileSize: any;
  updated_At: any;
  updated_By: any;
  created_At: any;
  created_By: any;
  description: any;
  tag: any;
  staff: any;
  documentPath: any;
  contextId:any
}

export class DocumentDetail {
  documentId: any;
  documentTypeId: any;
  accountingFirmId: any;
  flag: any;
  docValue: any;
  IsVisibleValue: any;
}

export class DocFilter {
  public jobId: any = 0;
  public tempId: any = 0;
  public tagId: any = "";
  public privacy: any = "";
  public staffId: any;
  public updatedDate: Date;
}

export class fileStrct {
  public _ClientJobs: any;
  public _ClientJobsFolders: any;
  public _ClientsFolders: any;
}

export class DynamicQuaote {
  NarrationId: any = 0;
  Narration: string;
  PlannedHours: string;
  NarrationAmt: string;
}

export class Address {
  public addressId: number
  public addressType: string
  public addressLine1: string
  public addressLine2: string
  public suburb: string
  public state: string
  public country: string
  public postcode: string
  public contestId: number
  public contestType: string
  public created_By: string
}

export class Corporate {
  public CorporateEntityID: any;
  public EntityID: any;
  public EntityType: any;
  public TrustType: string;
  public NameOfEntity: string;
  public Partner_Name: string;
  public TaxAgent_Name: string;
  public BareTrust: boolean;
  public Created_By: string;
  public TFN: string;
  public trustName :string
  public ABN :string
  public ACN :string
  public trustCompanyName:string
  public taxAgentId :string
  public anniversaryDate:any
}

export class PersonalDetails{
  public Id: number;
  public clientId:number
  public entityId:number
  public title: string
  public firstName: string
  public middleName :string
  public surname:string
  public lastName: string
  public gender: string
  public dateOfBirth: Date;
  public dob: any
  public homePhone: any
  public mobileNumber: any
  public workPhone: any
  public email: any
  public addresses:Address[]=[]
}

export class Users {
  UserId: string;
  AccountingFirmId: number;
  RoleId: number;
  RoleName: string;
  FirstName: string;
  LastName: string;
  Location: string;
  Address: string;
  EmployeeType: string;
  JobType: string;
  IsASICAgent: boolean;
  IsBASAgent: boolean;
  IsTaxAgent: boolean;
  IsAuditor: boolean;
  IsFinancialPlanner: boolean;
  Email: string;
  Password: string;
  ConfirmPassword: string;
  Phone: string;
  Mobile: string;
  FirmName: string;
}
